import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Package, TrendingUp, TrendingDown, Warehouse as WarehouseIcon, Truck, ClipboardList, BarChart3, AlertCircle, CheckCircle, ArrowDownToLine, ArrowUpFromLine } from 'lucide-react';
export function WarehouseDashboard() {
  const inboundOrders = [{
    id: 'INB-001',
    poNumber: 'PO-2023-001',
    supplier: 'Indofood',
    products: 'Indomie Goreng (500 Karton)',
    expectedDate: 'Hari ini, 14:00',
    status: 'in_transit',
    statusLabel: 'Dalam Perjalanan'
  }, {
    id: 'INB-002',
    poNumber: 'PO-2023-005',
    supplier: 'Danone',
    products: 'Aqua Galon (200 Galon)',
    expectedDate: 'Besok, 10:00',
    status: 'scheduled',
    statusLabel: 'Terjadwal'
  }];
  const outboundOrders = [{
    id: 'OUT-001',
    poNumber: 'PO-2023-001',
    cooperative: 'Koperasi Maju Jaya',
    destination: 'Bogor, Jawa Barat',
    items: 32,
    status: 'ready',
    statusLabel: 'Siap Kirim',
    courier: 'JNE',
    pickupTime: 'Hari ini, 15:00'
  }, {
    id: 'OUT-002',
    poNumber: 'PO-2023-003',
    cooperative: 'Koperasi Sejahtera',
    destination: 'Bandung, Jawa Barat',
    items: 45,
    status: 'pickup',
    statusLabel: 'Pickup',
    courier: 'Self Pickup',
    pickupTime: 'Besok, 09:00'
  }];
  return <div className="space-y-6" data-id="element-3556">
      {/* Header */}
      <div data-id="element-3557">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-3558">Dashboard Gudang</h2>
        <p className="text-sm text-slate-500 mt-1" data-id="element-3559">
          Gudang Transit Bogor - Monitor inbound & outbound
        </p>
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-4 gap-4" data-id="element-3560">
        <Card className="p-5 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-3561">
          <div className="flex items-center justify-between mb-3" data-id="element-3562">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3563">
              <WarehouseIcon className="w-6 h-6 text-white" data-id="element-3564" />
            </div>
            <Badge className="bg-blue-200 text-blue-800 border-0" data-id="element-3565">64%</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-3566">Kapasitas Terpakai</p>
          <p className="text-4xl font-bold text-blue-900" data-id="element-3567">3,200</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-3568">dari 5,000 unit</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-3569">
          <div className="flex items-center justify-between mb-3" data-id="element-3570">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3571">
              <ArrowDownToLine className="w-6 h-6 text-white" data-id="element-3572" />
            </div>
            <Badge className="bg-green-200 text-green-800 border-0" data-id="element-3573">+12</Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-3574">Inbound Hari Ini</p>
          <p className="text-4xl font-bold text-green-900" data-id="element-3575">12</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-3576">pesanan masuk</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-3577">
          <div className="flex items-center justify-between mb-3" data-id="element-3578">
            <div className="w-12 h-12 bg-violet-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3579">
              <ArrowUpFromLine className="w-6 h-6 text-white" data-id="element-3580" />
            </div>
            <Badge className="bg-violet-200 text-violet-800 border-0" data-id="element-3581">
              +18
            </Badge>
          </div>
          <p className="text-sm text-violet-700 mb-1" data-id="element-3582">Outbound Hari Ini</p>
          <p className="text-4xl font-bold text-violet-900" data-id="element-3583">18</p>
          <p className="text-xs text-violet-600 mt-1" data-id="element-3584">pesanan keluar</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-3585">
          <div className="flex items-center justify-between mb-3" data-id="element-3586">
            <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3587">
              <ClipboardList className="w-6 h-6 text-white" data-id="element-3588" />
            </div>
            <Badge className="bg-amber-200 text-amber-800 border-0" data-id="element-3589">
              Pending
            </Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-3590">Pending Orders</p>
          <p className="text-4xl font-bold text-amber-900" data-id="element-3591">25</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-3592">menunggu proses</p>
        </Card>
      </div>

      {/* Inbound & Outbound */}
      <div className="grid grid-cols-2 gap-6" data-id="element-3593">
        {/* Inbound */}
        <Card className="p-6" data-id="element-3594">
          <div className="flex items-center justify-between mb-6" data-id="element-3595">
            <div data-id="element-3596">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-3597">
                Inbound Orders
              </h3>
              <p className="text-sm text-slate-500 mt-1" data-id="element-3598">
                Barang masuk dari pabrik
              </p>
            </div>
            <Badge variant="success" className="flex items-center gap-1" data-id="element-3599">
              <ArrowDownToLine className="w-4 h-4" data-id="element-3600" />
              {inboundOrders.length}
            </Badge>
          </div>

          <div className="space-y-3" data-id="element-3601">
            {inboundOrders.map(order => <div key={order.id} className="p-4 bg-green-50 rounded-lg border border-green-200" data-id="element-3602">
                <div className="flex items-start justify-between mb-3" data-id="element-3603">
                  <div data-id="element-3604">
                    <div className="flex items-center gap-2 mb-1" data-id="element-3605">
                      <h4 className="font-bold text-slate-900" data-id="element-3606">
                        {order.poNumber}
                      </h4>
                      <Badge variant={order.status === 'in_transit' ? 'warning' : 'neutral'} className="text-xs" data-id="element-3607">
                        {order.statusLabel}
                      </Badge>
                    </div>
                    <p className="text-sm text-slate-600" data-id="element-3608">
                      Dari: {order.supplier}
                    </p>
                  </div>
                </div>
                <p className="text-sm text-slate-700 mb-2" data-id="element-3609">{order.products}</p>
                <div className="flex items-center justify-between text-xs" data-id="element-3610">
                  <span className="text-slate-600" data-id="element-3611">
                    ETA: {order.expectedDate}
                  </span>
                  <Button variant="outline" size="sm" data-id="element-3612">
                    Terima Barang
                  </Button>
                </div>
              </div>)}
          </div>
        </Card>

        {/* Outbound */}
        <Card className="p-6" data-id="element-3613">
          <div className="flex items-center justify-between mb-6" data-id="element-3614">
            <div data-id="element-3615">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-3616">
                Outbound Orders
              </h3>
              <p className="text-sm text-slate-500 mt-1" data-id="element-3617">
                Barang keluar ke koperasi
              </p>
            </div>
            <Badge variant="warning" className="flex items-center gap-1" data-id="element-3618">
              <ArrowUpFromLine className="w-4 h-4" data-id="element-3619" />
              {outboundOrders.length}
            </Badge>
          </div>

          <div className="space-y-3" data-id="element-3620">
            {outboundOrders.map(order => <div key={order.id} className="p-4 bg-blue-50 rounded-lg border border-blue-200" data-id="element-3621">
                <div className="flex items-start justify-between mb-3" data-id="element-3622">
                  <div data-id="element-3623">
                    <div className="flex items-center gap-2 mb-1" data-id="element-3624">
                      <h4 className="font-bold text-slate-900" data-id="element-3625">
                        {order.poNumber}
                      </h4>
                      <Badge variant={order.status === 'ready' ? 'success' : 'neutral'} className="text-xs" data-id="element-3626">
                        {order.statusLabel}
                      </Badge>
                    </div>
                    <p className="text-sm text-slate-600" data-id="element-3627">
                      Ke: {order.cooperative}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-sm text-slate-700 mb-2" data-id="element-3628">
                  <span data-id="element-3629">{order.items} Item</span>
                  <span className="text-slate-400" data-id="element-3630">•</span>
                  <span data-id="element-3631">{order.destination}</span>
                </div>
                <div className="flex items-center justify-between text-xs" data-id="element-3632">
                  <span className="text-slate-600" data-id="element-3633">
                    {order.courier} - {order.pickupTime}
                  </span>
                  <Button variant="outline" size="sm" data-id="element-3634">
                    Cetak Label
                  </Button>
                </div>
              </div>)}
          </div>
        </Card>
      </div>

      {/* Warehouse Stats */}
      <div className="grid grid-cols-2 gap-6" data-id="element-3635">
        <Card className="p-6" data-id="element-3636">
          <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-3637">
            Kapasitas Gudang
          </h3>
          <div className="mb-6" data-id="element-3638">
            <div className="flex justify-between items-center mb-2" data-id="element-3639">
              <span className="text-sm text-slate-600" data-id="element-3640">Terpakai</span>
              <span className="text-sm font-bold text-slate-900" data-id="element-3641">
                3,200 / 5,000 unit
              </span>
            </div>
            <div className="w-full h-4 bg-slate-100 rounded-full overflow-hidden" data-id="element-3642">
              <div className="h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full" style={{
              width: '64%'
            }} data-id="element-3643"></div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-3644">
            <div className="p-3 bg-green-50 rounded-lg border border-green-200" data-id="element-3645">
              <p className="text-xs text-green-700 mb-1" data-id="element-3646">Inbound Today</p>
              <p className="text-2xl font-bold text-green-900" data-id="element-3647">12</p>
            </div>
            <div className="p-3 bg-violet-50 rounded-lg border border-violet-200" data-id="element-3648">
              <p className="text-xs text-violet-700 mb-1" data-id="element-3649">Outbound Today</p>
              <p className="text-2xl font-bold text-violet-900" data-id="element-3650">18</p>
            </div>
          </div>
        </Card>

        <Card className="p-6" data-id="element-3651">
          <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-3652">
            Alerts & Tasks
          </h3>
          <div className="space-y-3" data-id="element-3653">
            <div className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg" data-id="element-3654">
              <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-3655" />
              <div data-id="element-3656">
                <h4 className="text-sm font-bold text-amber-800" data-id="element-3657">
                  Low Stock Alert
                </h4>
                <p className="text-xs text-amber-600 mt-1" data-id="element-3658">
                  5 produk di bawah minimum stock
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-200 rounded-lg" data-id="element-3659">
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-3660" />
              <div data-id="element-3661">
                <h4 className="text-sm font-bold text-green-800" data-id="element-3662">
                  All Systems Normal
                </h4>
                <p className="text-xs text-green-600 mt-1" data-id="element-3663">
                  Operasional gudang berjalan lancar
                </p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}